import { formatDate } from 'shared/helpers/date-time';
import { NextRouter } from 'next/router';

export enum TabValue {
  details = 'Details',
  activity = 'Activity',
  rewards = 'My Rewards',
  referrals = 'Referrals',
}

export enum RedemptionType {
  discount = 'discount',
  cash = 'cash',
}

export enum Mode {
  discount = 'PointsToDiscount',
  cash = 'CashBack',
}

export enum TierEarningBasis {
  points = 'points',
  dollars = 'dollars',
}

export enum TransactionType {
  redeemed = 'redeemed',
  newCustomerReward = 'New Customer Reward',
  manualAdjustment = 'Manual Adjustment',
  bulkUpdate = 'Bulk Update',
  migratedCarryover = 'Migrated Carryover',
  transactionReward = 'Transaction Reward',
  transactionSpend = 'Transaction Spend',
  returnedItem = 'Returned Item',
  voidedTransaction = 'Voided Transaction',
}

export type TabOption = {
  value: TabValue;
  label: string;
  sublabel?: string;
  data?: React.ReactNode;
  display?: boolean;
};

export type DPOSRewardsTabsProps = {
  children: React.ReactNode;
  onTabChange: (tab: string) => void;
  selectedTab: TabValue;
  tabOptions: TabOption[];
  showFeeBadgeInline?: boolean;
};

export const formatTransactionDate = (dateString: string): string => {
  const convertedDate = formatDate(dateString, 'MM/DD/YYYY');
  const date = new Date(dateString);
  const time = date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });

  return `${convertedDate} at ${time}`;
};

export const isReferralsRoute = (router: NextRouter): boolean =>
  router.pathname.includes('/referral') || router.asPath.includes('/referral');

export const getDefaultTab = (
  redemptionType?: string | null,
  hasRewardsActivity?: boolean | null,
  isShowReferralsEnabled?: boolean | null
): TabValue => {
  if (redemptionType?.toLowerCase() === RedemptionType.discount) {
    return TabValue.rewards;
  }
  if (!hasRewardsActivity && isShowReferralsEnabled) {
    return TabValue.referrals;
  }
  return TabValue.activity;
};
